import { render } from "./Mini.vue?vue&type=template&id=0d716f00"
import script from "./Mini.vue?vue&type=script&lang=js"
export * from "./Mini.vue?vue&type=script&lang=js"

import "./Mini.vue?vue&type=style&index=0&id=0d716f00&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__